import { IUserState } from "../../interface/userstate";
interface IUserStatePrv extends IUserState {
    name: string,
    collection: { [key: string]: any },
}

const StoreSymbol = Symbol.for('user-state');

function _saveUserState(key: string, state: IUserStatePrv) {
    const store: { [keyof: string]: IUserStatePrv } = (global as any)[StoreSymbol]
        ?? {};
    store[key] = state;
    (global as any)[StoreSymbol] = store;
}

function _userState(name: string): IUserStatePrv|null {
    const store: { [keyof: string]: IUserStatePrv } = (global as any)[StoreSymbol]
        ?? {};
    const val = store[name];
    return val;
}

function _GetValue(state: IUserStatePrv, key: string): any|undefined {
    return state.collection[key];
}

function _SetValue(state: IUserStatePrv, key: string, value: any|undefined) {
    if ( value === undefined ) {
        delete state.collection[key];
    } else {
        state.collection[key] = value;
    }
    _saveUserState(state.name, state);
}

function UserState(name: string): IUserState {
    const val: IUserStatePrv = _userState(name) || {
        name,
        collection: {},
        getProperty: function<T>(this: IUserStatePrv, key: string) {
            return _GetValue(this, key) as T|undefined;
        },
        setProperty: function(this: IUserStatePrv, key: string, value: any|undefined) {
            _SetValue(this, key, value)
        },
    };
    return val as IUserState;
}
export default UserState